import React, { useState, useEffect } from 'react'
import { errorEmitter } from '../../../services/axios-instance'
import Modal from '../../organisms/modal/modal'
import Button from '../../atoms/button/button'

const GlobalErrorModal = () => {
	const [error, setError] = useState(null)
	const [showModal, setShowModal] = useState(false)

	useEffect(() => {
		const handleError = event => {
			setError(event.detail.message)
			setShowModal(true)
		}

		errorEmitter.addEventListener('apiError', handleError)

		return () => {
			errorEmitter.removeEventListener('apiError', handleError)
		}
	}, [])

	const handleCloseModal = () => {
		setShowModal(false)
		setError(null)
	}

	if (!error || !showModal) {
		return null
	}

	return (
		<Modal
			showModal={showModal}
			setShowModal={setShowModal}
			data-testid='mock-modal'
		>
			<p className='f-modal__txt error'>Error</p>
			<p className='f-modal__sub-text error'>{error}</p>
			<div className='f-modal__buttons'>
				<Button text='Aceptar' action={handleCloseModal} />
			</div>
		</Modal>
	)
}

export default GlobalErrorModal
